module.exports = __webpack_public_path__ + "static/media/icon_segmento.fea23d62.svg";